import { ApiEndpoints } from "@shared/api/api-endpoints";
import {
  RecommendationsDashboardKpisResponse,
  SystemAlertRecommendationFilters,
  SystemAlertRecommendationsResponse,
} from "./types";
import { axApiClient } from "@shared/api/clients/apiClientFactory";

export const axSystemAlertsApi = {
  getRecommendationsDashboardKpis: async (
    remoteUtilityId: string
  ): Promise<RecommendationsDashboardKpisResponse> => {
    // CHANGE: Update the URL path
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "ax",
      "alerts/dashboard",
      (query) => {
        query.push("remote_utility_id", remoteUtilityId);
      }
    );

    const response = await axApiClient.get(url);
    return response.data;
  },

  getRecommendations: async (
    remoteUtilityId: string,
    filters: SystemAlertRecommendationFilters = {}
  ): Promise<SystemAlertRecommendationsResponse> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "ax",
      "alerts",
      (query) => {
        query.push("remote_utility_id", remoteUtilityId);

        // Add pagination (with defaults)
        query.push("page", (filters.page || 1).toString());
        query.push("limit", (filters.limit || 25).toString());

        // Add search if provided
        if (filters.search) {
          query.push("search", filters.search);
        }

        // Add generateDate filter (NEW)
        if (filters.generateDate) {
          query.push("create_date", filters.generateDate);
        }

        // Add status filters
        if (filters.status) {
          query.push("status", filters.status);
        }

        // Add priority filter
        if (filters.priority) {
          query.push("priority", filters.priority);
        }
      }
    );

    const response = await axApiClient.get(url);
    return response.data;
  },

  dismissAlert: async (alertId: number): Promise<{ message: string }> => {
    const url = ApiEndpoints.createUrl("ax", `alerts/${alertId}/action`);

    const response = await axApiClient.put(url, {
      action: "dismiss",
    });

    return response.data;
  },

  reviewAlert: async (alertId: number): Promise<{ message: string }> => {
    const url = ApiEndpoints.createUrl("ax", `alerts/${alertId}/action`);

    const response = await axApiClient.put(url, {
      action: "review",
    });

    return response.data;
  },
};
